/*
 * @Author: Hong.Zhang
 * @Date: 2023-11-09 16:34:37
 * @Description:
 */
export const COLORS = {
  // brand
  primary: 'primary',
  secondary: 'secondary',
  //functional
  success: 'success',
  error: 'error',
  warning: 'warning',
  info: 'info',
  // neutral
  black: 'black',
  gray: 'gray',
  white: 'white',
} as const;

type COLOR_TYPE = typeof COLORS;
export type COLOR_VALUE_TYPE = COLOR_TYPE[keyof COLOR_TYPE];

export const DEFAULT_COLOR_PLATE: Record<COLOR_VALUE_TYPE, string> = {
  [COLORS.primary]: '#239CEC',
  [COLORS.secondary]: '#F96706',
  [COLORS.success]: '#2ed573',
  [COLORS.error]: '#FF5245',
  [COLORS.warning]: '#cf8909',
  [COLORS.info]: '#1e90ff',
  [COLORS.black]: '#1C1F23',
  [COLORS.gray]: '#EAEAEA',
  [COLORS.white]: '#ffffff',
};
